import * as React from "react";
import * as PropTypes from "prop-types";

export class Error extends React.PureComponent<any, any> {
  render() {
    return (
        <div className="row">
            <div className="col-12 text-danger">
                {this.props.message}
            </div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Controls/Error.tsx